export default __webpack_public_path__ + "85deb51b66b659ae8ca4f84529d3a802.png";